import { Routes } from '@angular/router';
import { authGuard } from './guard/auth-guard';
import { InvalidUrlComponent } from './layouts/shared/invalid-url-component/invalid-url.component';

export const routes: Routes = [
  {
    path: 'zoho/callback',
    title: 'Zoho Callback',
    loadComponent: () =>
      import('./layouts/authorized/zoho-authorized-component/zoho-authorized-component').then(
        (m) => m.ZohoAuthorizedComponent,
      ),
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./layouts/unauthorized/sigin-component/signin.component').then((m) => m.SigninComponent),
  },
  {
    path: 'building/image_view/:buildingId',
    loadComponent: () =>
      import('./layouts/unauthorized/propery-image-view-component/propery-image-view-component').then(
        (m) => m.PropertyImageViewComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./layouts/authorized/authorized-component/authorized.routes').then((m) => m.authorizedRoutes),
  },
  {
    path: '**',
    title: 'Invalid URL',
    loadComponent: () =>
      import('./layouts/shared/invalid-url-component/invalid-url.component').then((m) => m.InvalidUrlComponent),
  },
];
